// extracted by mini-css-extract-plugin
export default {"action":"PastRatesList_action__VHYPm","deleteAction":"PastRatesList_deleteAction__W-3FQ","expandedRow":"PastRatesList_expandedRow__2Arjt","card":"PastRatesList_card__gTDHg"};